import React from 'react';
import { Globe, Users, Code } from 'lucide-react';

/**
 * Компонент для выбора параметров разработки AR-проекта
 */
const DevelopmentOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  developmentRegions,
  developmentTeams
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Code className="w-5 h-5 mr-2 text-green-500" />
        Условия разработки
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Регион разработки */}
        <div>
          <label htmlFor="developmentRegion" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Globe className="w-4 h-4 mr-2 text-green-500" />
            Регион разработки
          </label>
          <select
            id="developmentRegion"
            name="developmentRegion"
            value={formData.developmentRegion}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.developmentRegion ? 'input-error' : ''}`}
          >
            {developmentRegions.map((region) => (
              <option key={region.id} value={region.id}>
                {region.name} - {region.description}
              </option>
            ))}
          </select>
          {errors.developmentRegion && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.developmentRegion}
            </p>
          )}
        </div>

        {/* Тип команды */}
        <div>
          <label htmlFor="developmentTeam" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-green-500" />
            Тип команды разработки
          </label>
          <select
            id="developmentTeam"
            name="developmentTeam"
            value={formData.developmentTeam}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.developmentTeam ? 'input-error' : ''}`}
          >
            {developmentTeams.map((team) => (
              <option key={team.id} value={team.id}>
                {team.name} - {team.description}
              </option>
            ))}
          </select>
          {errors.developmentTeam && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.developmentTeam}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <Users className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              О выборе команды разработки
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Регион разработки и тип команды оказывают существенное влияние на стоимость. 
              Агентства обеспечивают полный цикл разработки с меньшими рисками, но за более высокую цену. 
              Фрилансеры могут быть более экономичным вариантом, но требуют большего управления с вашей стороны.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentOptionsSection;